// @ts-check
/** Index static horizontal geometry. Queries preserve authored order for deterministic contacts.
 * @template {{x:number,width:number}} T
 * @param {readonly T[]} objects @param {number} [cellWidth]
 */
export function createSpatialIndex(objects, cellWidth = 256) {
  if (!(cellWidth > 0) || !Number.isFinite(cellWidth)) throw new RangeError('Invalid spatial cell width');
  /** @type {Map<number,number[]>} */
  const cells = new Map();
  objects.forEach((object, index) => {
    const first = Math.floor(object.x / cellWidth);
    const last = Math.floor((object.x + object.width) / cellWidth);
    for (let cell = first; cell <= last; cell++) {
      const members = cells.get(cell) ?? [];
      members.push(index); cells.set(cell, members);
    }
  });
  return {
    /** @param {number} left @param {number} right */
    query(left, right) {
      if (!Number.isFinite(left) || !Number.isFinite(right) || right < left) return [];
      const found = new Set();
      for (let cell = Math.floor(left / cellWidth); cell <= Math.floor(right / cellWidth); cell++) {
        for (const index of cells.get(cell) ?? []) found.add(index);
      }
      return [...found].sort((a, b) => a - b).map((index) => objects[index]).filter((object) => object.x <= right && object.x + object.width >= left);
    },
  };
}
